<template>
    <form class="form-horizontal group-border-dashed" @submit.prevent="handleSubmit" novalidate>
        <div class="form-group">
            <h3 class="wizard-title text-uppercase">Situationsanalyse – Systeme</h3>
        </div>

        <check-question
            name="systems_cms"
            title="Arbeiten Sie mit einem CMS?"
            subtitle="Bitte eines der unten vorgeschlagenen Systeme auswählen, falls das System fehlt bitte rechts in der Spalte Bemerkungen notieren."
            :notes.sync="formData.systems_cms_notes"
            :disabled="disabled"
        >
            <multi-select
                slot="input"
                name="systems_cms"
                optionsKey="cms"
                subject="Neues CMS erfassen"
                :disabled="disabled"
                v-model="formData.systems_cms"
                :validation="$v.formData.systems_cms"
            />
            <template #description>
                <h4>CMS - Content Management Systeme</h4>
                <p>Diese Kategorie umfasst Systeme mit denen ein Anwender ohne Programmierkenntnisse in der Lage ist unstrukturierte Inhalte ins Internet zu stellen.</p>
            </template>
        </check-question>

        <check-question
            name="systems_dam"
            title="Arbeiten Sie mit einem DAM?"
            subtitle="Bitte eines der unten vorgeschlagenen Systeme auswählen, falls das System fehlt bitte rechts in der Spalte Bemerkungen notieren."
            :notes.sync="formData.systems_dam_notes"
            :disabled="disabled"
        >
            <multi-select
                slot="input"
                name="systems_dam"
                optionsKey="dam"
                subject="Neues DAM erfassen"
                :disabled="disabled"
                v-model="formData.systems_dam"
                :validation="$v.formData.systems_dam"
            />
            <template #description>
                <h4>DAM - Digital Asset Management</h4>
                <p>Diese Kategorie umfasst Systeme mit denen Medien wie Fotos, Grafiken, Videos, Dokumente strukturiert und zentral verwaltet und mit Dritten geteilt werden können.</p>
            </template>
        </check-question>

        <check-question
            name="systems_pim"
            title="Arbeiten Sie mit einem PIM?"
            subtitle="Bitte eines der unten vorgeschlagenen Systeme auswählen, falls das System fehlt bitte rechts in der Spalte Bemerkungen notieren."
            :notes.sync="formData.systems_pim_notes"
            :disabled="disabled"
        >
            <multi-select
                slot="input"
                name="systems_pim"
                optionsKey="pim"
                subject="Neues PIM erfassen"
                :disabled="disabled"
                v-model="formData.systems_pim"
                :validation="$v.formData.systems_pim"
            />
            <template #description>
                <h4>PIM - Product Information Management</h4>
                <p>Diese Kategorie umfasst Systeme denen Anwender in der Lage sind strukturierte Inhalte wie POI (Point of Interests), Routen, Events oder auch Artikel zu verwalten, zu veredeln und über Schnittstellen an Dritte weiterzugeben.</p>
            </template>
        </check-question>

        <check-question
            name="systems_crm"
            title="Arbeiten Sie mit einem CRM?"
            subtitle="Bitte eines der unten vorgeschlagenen Systeme auswählen, falls das System fehlt bitte rechts in der Spalte Bemerkungen notieren."
            :notes.sync="formData.systems_crm_notes"
            :disabled="disabled"
        >
            <multi-select
                slot="input"
                name="systems_crm"
                optionsKey="crm"
                subject="Neues CRM erfassen"
                :disabled="disabled"
                v-model="formData.systems_crm"
                :validation="$v.formData.systems_crm"
            />
            <template #description>
                <h4>CRM - Customer Relationship Management</h4>
                <p>Diese Kategorie umfasst Systeme mit denen Anwender ihre Kundendaten (Organisationen und Personen) zentral und strukturiert verwalten können.</p>
            </template>
        </check-question>

        <check-question
            name="systems_erp"
            title="Arbeiten Sie mit einem ERP?"
            subtitle="Bitte eines der unten vorgeschlagenen Systeme auswählen, falls das System fehlt bitte rechts in der Spalte Bemerkungen notieren."
            :required="!disabled"
            :notes.sync="formData.systems_erp_notes"
            :disabled="disabled"
        >
            <multi-select
                slot="input"
                name="systems_erp"
                optionsKey="erp"
                subject="Neues ERP erfassen"
                :required="!disabled"
                :disabled="disabled"
                v-model="formData.systems_erp"
                :validation="$v.formData.systems_erp"
            />
            <template #description>
                <h4>ERP - Enterprise Ressource Planning</h4>
                <p>Diese Kategorie umfasst Systeme welche den Anwender in der Ausführung seiner Kernprozesse unterstützt. Dazu gehören Aktivitäten wie Offertwesen, Verkauf, Auftragsabwicklung (Personalplanung, Einsatzplanungen, Ressourcenplanungen, Verfügbarkeiten usw) Leistungserfassung und Faktura.</p>
            </template>
        </check-question>

        <div class="form-group" v-if="!disabled">
            <button class="btn btn-lg btn-secondary btn-space" type="button" @click.prevent="$emit('previous', formData)">zurück</button>
            <button class="btn btn-lg btn-primary btn-space wizard-next" type="submit">weiter</button>
        </div>
    </form>
</template>

<script>
    import { required } from 'vuelidate/lib/validators';

    import exam from '../../../mixins/exam';

    import CheckQuestion from './Question';
    import MultiSelect from '../../widgets/MultiSelect';

    export default {
        mixins: [exam],
        components: { CheckQuestion, MultiSelect },

        data: () => ({
            formData: {
                systems_cms: [],
                systems_cms_notes: '',
                systems_dam: [],
                systems_dam_notes: '',
                systems_pim: [],
                systems_pim_notes: '',
                systems_crm: [],
                systems_crm_notes: '',
                systems_erp: [],
                systems_erp_notes: '',
            },
        }),

        validations: {
            formData: {
                systems_cms: { required },
                systems_dam: { required },
                systems_pim: { required },
                systems_crm: { required },
                systems_erp: { required },
            },
        },
    };
</script>
